import { Button, Modal } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { faCompressAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { DropdownList } from 'react-widgets';
import { getSeances, moveToOccasionSeance } from 'src/store/actions/seance-actions';
import { getCasesAnother } from 'src/store/actions/case-actions';
import { StoreState } from 'src/store/reducers';
import { Dispatch } from 'redux';
import { QueryParams } from 'src/types/grid';
import { ICase } from 'src/types/case';
import { Paginated } from 'src/services/api-handlers/pagination';
import Loader from '../../../../../../../../../components/Loader';
import OrderEnum from '../../../../../../../../../enumerables/order-enum';
import { getValFromEnum } from '../../../../../../../../../components/redux-form/utils/dropdown-values';

export interface StateProps {
    casesOther: Paginated<ICase>;
    inProgressOther: boolean;
}

export interface DispatchProps {
    getCasesAnother: (params: QueryParams) => void;
    move: (id: string, occasion: string, handleClose: () => void) => void;
}

interface OwnProps {
    caseValues: SelectObject[];
    caseCurrent: Partial<ICase> | null;
    providerId: string;
    month: { monthEnd: string; monthStart: string };
    sessionId: string | number;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}
const ChangeCaseComponent: React.FunctionComponent<Props> = ({
    caseCurrent,
    sessionId,
    move,
    inProgressOther,
    casesOther,
    getCasesAnother,
    month,
}: Props) => {
    const [idCase, setCase] = useState<string | number | undefined>(caseCurrent?.id);
    const inputEl = React.useRef(null);
    const [open, setOpen] = useState<boolean>(false);

    const typeEnum = OrderEnum ? OrderEnum.getEnum('OrderType') : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            getCasesAnother({
                page: 1,
                filters: {
                    'student.id': caseCurrent?.student?.id,
                    'seanceDate[after]': month.monthStart,
                    'seanceDate[before]': month.monthEnd,
                },
                itemsPerPage: 1200,
            });
        }
        // eslint-disable-next-line
    }, [open]);
    const caseValues: SelectObject[] = [];

    casesOther.list.forEach((cas: Partial<ICase>) => {
        let name = '';
        const caseId = '#' + cas.id + '; ';
        let orderType = '';
        let caseNumber = '';
        if (cas.caseType === 1) {
            caseNumber = cas.caseNumber ? cas.caseNumber + ',' : '';
        }
        if (cas.caseType === 3) {
            name = cas.district ? `${cas.district.name}` : 'unknown';
        } else if (cas.caseType === 4) {
            name = cas.vendor ? `${cas.vendor.name}` : 'unknown';
        } else {
            name = cas.student ? `${cas.student.firstName} ${cas.student.lastName}` : 'unknown';
        }
        if (cas.orderType) {
            const valueOrderType = orderTypes.find((it) => it.value === cas.orderType);
            orderType = valueOrderType?.label ? '; ' + valueOrderType?.label + '; ' : '';
        }

        let serviceType = cas?.serviceType?.title;
        if (!serviceType) {
            serviceType = cas?.serviceType?.cpt;
        }
        const serviceLocation =
            cas?.occasionServiceLocations && cas?.occasionServiceLocations[0]?.serviceLocation
                ? `, ${cas?.occasionServiceLocations[0].serviceLocation?.title}`
                : '';

        const titleCase = `${caseId}${name}${orderType} ( ${caseNumber} ${serviceType}${serviceLocation}  )`;

        caseValues.push({ value: `${cas.id}`, label: titleCase });
    });
    const caseCurrentSel = { value: `${idCase}`, label: `${idCase}` };
    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */
    /* eslint-enable */

    return (
        <>
            <button ref={inputEl} className="changeButton" type="button" onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={faCompressAlt} />
                <span></span>
            </button>
            {inProgressOther ? (
                <Loader />
            ) : (
                <Modal show={open} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Move Case to</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Case#
                        <DropdownList
                            //       this.state.status statusItems
                            data={caseValues}
                            textField="label"
                            valueField="value"
                            onChange={(item: SelectObject) => {
                                // const valueObj = caseValues.find((itS => itS.value === caseCurrentValue))
                                setCase(item?.value);
                            }}
                            value={caseCurrentSel}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={() => move(`${sessionId}`, `${idCase}`, handleClose)}>
                            Yes
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};
function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        casesOther: state.cases.dataOther,
        inProgressOther: state.cases.inProgressOther,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCasesAnother: (params: QueryParams) => dispatch(getCasesAnother(params)),
        move: (id: string, occasion: string, handleClose: () => void) =>
            dispatch(
                moveToOccasionSeance(
                    { id, occasion },
                    () => {
                        toast.success('Session successfully changed');
                        handleClose();

                        dispatch(
                            getSeances({
                                page: 1,
                                filters: {
                                    'occasion.id': ownProps?.caseCurrent?.id && +ownProps.caseCurrent.id,
                                    'provider.id': ownProps.providerId,
                                    'seanceDate[after]': ownProps.month.monthStart,
                                    'seanceDate[before]': ownProps.month.monthEnd,
                                    'order[seanceDate]': 'asc',
                                },
                                itemsPerPage: 1200,
                            }),
                        );
                    },
                    (errorMessage: string) => {
                        handleClose();
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ChangeCaseComponent);
